import { jsx as _jsx } from "react/jsx-runtime";
import { uploadDialogueImage } from '../../api/dialogue-images';
import { EntityBulkUploadModal } from '../EntityBulkUploadModal/EntityBulkUploadModal';
export const DialoguesBulkUploadModal = (props) => (_jsx(EntityBulkUploadModal, Object.assign({}, props, { title: "Bulk Upload Dialogue Images", upload: uploadDialogueImage, uploadView: "fileList", resultView: "summaryWithErrors" })));
export default DialoguesBulkUploadModal;
